import React from "react";
import { Link } from "react-router-dom";
import { JOURNAL } from "../../data/journal";
import { SITE_IMAGES } from "../../data/siteImages";
import PlantImage from "../../components/fancyplants/PlantImage";
import Seo from "../../components/fancyplants/Seo";
import { formatDate } from "../../utils/format";

export default function JournalPage() {
  const [lead, ...rest] = JOURNAL;
  return (
    <div className="pt-24">
      <Seo
        title="Journal"
        description="Seasonal notes from a small Irish plant shop — what's thriving, care tips for the local climate, and the occasional plant story."
        path="/journal"
      />
      <header className="container-fp grid items-center gap-8 py-12 md:grid-cols-[1fr_360px]">
        <div>
          <p className="eyebrow mb-2">The Journal</p>
          <h1 className="t-h1 max-w-2xl">Seasonal notes from a small plant shop</h1>
        </div>
        <PlantImage
          src={SITE_IMAGES.journalHero}
          alt="A potting bench with compost and plant care tools"
          ratio="4/3"
          className="rounded-3xl"
          priority
        />
      </header>

      {/* Lead post */}
      <div className="container-fp">
        <Link to={`/journal/${lead.slug}`} className="group grid gap-8 md:grid-cols-2 md:items-center">
          <PlantImage src={lead.cover} alt={lead.title} ratio="3/2" className="rounded-3xl" />
          <div>
            <p className="text-sm text-ink-soft">{formatDate(lead.date)} · {lead.readingTime}</p>
            <h2 className="mt-2 font-display text-3xl leading-tight group-hover:text-forest-700 sm:text-4xl">
              {lead.title}
            </h2>
            <p className="mt-3 t-lead">{lead.excerpt}</p>
            <span className="mt-4 inline-block font-semibold text-forest-700">Read more →</span>
          </div>
        </Link>
      </div>

      <div className="container-fp grid gap-6 py-14 md:grid-cols-2">
        {rest.map((post) => (
          <Link key={post.id} to={`/journal/${post.slug}`} className="group surface overflow-hidden hover:shadow-lift">
            <PlantImage src={post.cover} alt={post.title} ratio="2/1" />
            <div className="p-6">
              <p className="text-sm text-ink-soft">{formatDate(post.date)} · {post.readingTime}</p>
              <h3 className="mt-1 font-display text-2xl leading-tight group-hover:text-forest-700">{post.title}</h3>
              <p className="mt-2 text-ink-soft">{post.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
